import Vue from 'vue'
import Vuex from 'vuex'
import UserModule from './user'
import CountryModule from './country'
import CoinModule from './coin'
import ContinentModule from './continent'
import BanknoteModule from './banknote'
import BookModule from './book'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user: UserModule,
    country: CountryModule,
    continent: ContinentModule,
    coin: CoinModule,
    banknote: BanknoteModule,
    book: BookModule
  },
  plugins: [createPersistedState({
    storage: {
      getItem: key => Cookies.getJSON(key),
      setItem: (key, value) => Cookies.set(key, value, { secure: true }),
      removeItem: key => Cookies.remove(key)
    }
  })]
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js